import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { pick, omitBy } from 'lodash';
import classnames from 'classnames';
import Select from 'react-select';

import firebase from '../../firebase';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const defaultState = {
  id: null,
  nameForRB: '',
  nameForMail: '',
  validations: {},
  isSubmitting: false,
};
const { entries } = Object;

export default class HpOtherLabelFormModal extends Component {
  constructor() {
    super();
    this.state = { ...defaultState };
  }
  componentDidUpdate(prevProps, prevState) {
    if(!prevProps.isOpen && this.props.isOpen) {
      this.clear();
      this.setValues();
    }
  }
  clear() {
    this.setState({ ...defaultState });
  }
  setValues() {
    const { values } = this.props;
    this.setState({ ...omitBy(values, _ => _ === undefined) });
    entries(values || {}).forEach(([k, v]) => setTimeout(() => this.validate(k, v), 0));
  }
  validate = (propName, value) => {
    const { validations } = this.state;
    switch (propName) {
      case 'nameForRB': 
      case 'nameForMail': 
        this.setState({ validations: { ...validations, [propName]: !!value } });
        break;
      default:
        this.setState({ validations: { ...validations, [propName]: true } });
    }
  }
  validationCss(name) {
    const { validations: { [name]: isValid } } = this.state;
    return classnames({ 'is-valid': isValid, 'is-invalid': isValid === false });
  }
  onChange = (name, { target: { value } }) => {
    this.validate(name, value);
    this.setState({ [name]: value });
  }
  onSubmit = (event) => {
    event.preventDefault();
    if(this.isUnsubmittable()) return;
    const { onSubmit } = this.props;
    const values = pick(this.state, ['id', 'nameForRB', 'nameForMail']);
    this.setState({ isSubmitting: true });
    onSubmit(values);
  }
  isUnsubmittable() {
    const { isSubmitting, validations } = this.state;
    return isSubmitting || ['nameForRB', 'nameForMail'].some(_ => !validations[_]);
  }
  render() {
    const { values, isOpen, onClickClose } = this.props;
    const { nameForRB, nameForMail, } = this.state;
    const isNew = (values || {}).id == null;
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>
          HP看板{isNew ? '追加' : '編集'}
        </ModalHeader>
        <Form onSubmit={this.onSubmit}>
          <ModalBody>
            <FormGroup>
              <Label>レストランボードでの名称</Label>
              <Input value={nameForRB} onChange={this.onChange.bind(this, 'nameForRB')} className={this.validationCss('nameForRB')} />
            </FormGroup>
            <FormGroup>
              <Label>予約メールでの名称</Label>
              <Input value={nameForMail} onChange={this.onChange.bind(this, 'nameForMail')} className={this.validationCss('nameForMail')} />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={onClickClose}>Cancel</Button>
            <Button type="submit" color="primary" onClick={this.onSubmit} disabled={this.isUnsubmittable()}>保存</Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
};

